import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Box, Button, IconButton, Tab, Tabs, useTheme } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import i18n from 'i18n-js';

import VouchersTab from './components/VouchersTab';
import globalStore from 'store/globalStore';
import agent from 'api/agent';

enum VouchersTabs {
    Vouchers,
}

export default function VouchersPage() {
    const theme = useTheme();
    const dispatch = useDispatch();
    const history = useHistory();
    const [tabActive, setTab] = useState<VouchersTabs>(VouchersTabs.Vouchers);

    function handleChangeTab(event: React.ChangeEvent<{}>, view: number) {
        if (view !== tabActive) {
            setTab(view);
        }
    }

    async function getVouchersTemplate() {
        dispatch(globalStore.actionCreators.showSpiner());
        try {
            const response = await agent.Restaurants.GetVouchersTemplate();
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'vouchers-template.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            dispatch(globalStore.actionCreators.showToaster('error', error));
        } finally {
            dispatch(globalStore.actionCreators.hideSpiner());
        }
    }

    return (
        <>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                padding="0px 16px"
                borderBottom={`1px solid ${theme.palette.grey['300']}`}
            >
                <Box display="flex" alignItems="center">
                    <IconButton
                        aria-label="delete"
                        size="small"
                        color="primary"
                        onClick={() => history.goBack()}
                    >
                        <ArrowBackIcon fontSize="inherit" />
                    </IconButton>
                    <Tabs
                        value={tabActive}
                        onChange={handleChangeTab}
                        aria-label="wrapped label tabs example"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab
                            value={VouchersTabs.Vouchers}
                            label={i18n.t('navigationTabs.vouchers')}
                        />
                    </Tabs>
                </Box>
                <Button color="primary" variant="contained" onClick={getVouchersTemplate}>
                    + {i18n.t('vouchers.downloadTemplate')}
                </Button>
            </Box>
            {tabActive === VouchersTabs.Vouchers && <VouchersTab />}
        </>
    );
}
